import { INITIAL_GAME_ROW_REVEAL_STAGGER_MS } from "./constants";
import { marketingLiftGutterSx, marketingLiftSx } from "@/shared/theme/marketing-lift";

export const GAME_TABLE_ACTION_MIN_WIDTH = 132;
export const GAME_TABLE_COLUMN_WIDTHS = ["9%", "14%", "9%", "8%", "24%", "10%", "11%", "15%"] as const;
export const WIDE_GAME_COLUMN_INDEXES = [5] as const;
export const GAME_TABLE_ACTION_SX = {
  minWidth: { xs: 44, sm: 108 },
  ...marketingLiftGutterSx,
  width: "calc(100% - 10px)",
  mt: 0,
  mb: 0,
  minHeight: { xs: 44, sm: 36 },
  px: 1.25,
  color: "#0a0a0a",
  backgroundColor: "#f0ece2",
  border: "2px solid #0a0a0a",
  borderRadius: 0,
  fontSize: "0.6875rem",
  fontWeight: 800,
  letterSpacing: ".05em",
  ...marketingLiftSx(),
  "&:hover, &:focus-visible": {
    ...marketingLiftSx()["&:hover, &:focus-visible"],
    backgroundColor: "#f0ece2",
  },
} as const;

export const gameFormatEvidence = ({
  timeControl,
  exactTimeControl,
  rated,
}: {
  timeControl: string;
  exactTimeControl: string | null;
  rated: boolean | null;
}) =>
  [timeControl.toUpperCase(), exactTimeControl ?? "CLOCK UNKNOWN", rated == null ? null : rated ? "RATED" : "CASUAL"]
    .filter(Boolean)
    .join(" · ");

export const gameInitialRowRevealDelay = (index: number) => index * INITIAL_GAME_ROW_REVEAL_STAGGER_MS;

export const gameRowRevealObserverOptions = () => ({ rootMargin: "0px 0px -32px 0px", threshold: 0.01 }) as const;
